<template>
  <div v-if="isLoading" class="page-loader">
    <Loader class="loader-indicator" :loading="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Loader from '../Loader.vue';

export default {
  name: 'MainPageLoader',
  components: {
    Loader,
  },
  computed: {
    ...mapGetters({
      isLoading: 'core/isLoading',
    }),
  },
};
</script>

<style lang="scss" scoped>
  .page-loader {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, .8);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
